import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "moment/locale/ko";
import "../../assets/css/font.css";
import modalSmartStore from "../../assets/img/modal/modalSmartStore.png";

const SmartStoreModal = (oprops) => {
  const [modalOpen, setModalOpen] = useState(true);

  const closeModal = () => {
    setModalOpen(false);
  };
  const todayCloseModal = () => {
    const formattedDate = new Date().toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    localStorage.setItem("modalClosedToday" + formattedDate, "true");
    setModalOpen(false);
  };

  useEffect(() => {
    const formattedDate = new Date().toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const isModalClosedToday = localStorage.getItem(
      "modalClosedToday" + formattedDate
    );
    if (isModalClosedToday) {
      setModalOpen(false);
    }
  }, []);
  const openNotice = () => {
    window.open("https://behind.ivid.kr/", "_blank");
  };
  return (
    <ModalStyle>
      {modalOpen === true ? (
        <div className="modalPage">
          <div className="modalContainer">
            <div className="modalWrap">
              <button onClick={openNotice}>
                <img
                  src={modalSmartStore}
                  alt="스마트스토어 추가모집 이미지"
                  width="100%"
                />
              </button>
              <div className="closeFooter">
                <button onClick={todayCloseModal}>
                  <p>오늘 하루 그만보기</p>
                </button>
                <button onClick={closeModal}>
                  <p>닫기</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </ModalStyle>
  );
};

export default SmartStoreModal;

export const ModalStyle = styled.div`
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  button,
  input,
  textarea {
    transform: skew(-0.1deg);
    color: #000;
    font-family: "pretendard" !important;
    text-decoration: none;
  }
  .modalPage {
    position: fixed;
    overflow: hidden;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999;

    .modalContainer {
      position: relative;
      left: 72%;
      top: 53%;
      transform: translate(-50%, -50%);
      max-width: 539px;
    }
  }
  .modalWrap {
    background: none;

    button {
      padding: 0;
      background: none;
      border: none;
      outline: none;
    }
    .closeFooter {
      padding: 16px;
      background: #fff;
      display: flex;
      justify-content: flex-end;

      button {
        margin-left: 44px;

        p {
          margin: 0;
          color: #000;
          text-decoration: underline;
          text-underline-offset: 5px;
          font-size: 18px;
        }
      }
    }
  }

  @media (max-width: 800px) {
    .modalPage .modalContainer {
      width: 88%;
      position: relative;
      left: 52%;
      right: 48%;
      top: 55%;
      transform: translate(-50%, -50%);
      max-width: 539px;
    }
    .closeFooter button {
      p {
        font-size: 12px;
      }
    }
  }
`;
